export const questionsCategoryK: Record<string, PolicyFormQuestion> = {
  nicotineCigarettesUseFirstInsured: {
    id: 'nicotine-cigarettes-use-first-insured',
    questionRef: 'nicotineCigarettesUseFirstInsured',
    title: 'Within the past five (5) years, has the proposed insured used cigarettes?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotinePipeUseFirstInsured: {
    id: 'nicotine-pipe-use-first-insured',
    questionRef: 'nicotinePipeUseFirstInsured',
    title: 'Within the past five (5) years, has the proposed insured used a pipe?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotineCigarsUseFirstInsured: {
    id: 'nicotine-cigars-use-first-insured',
    questionRef: 'nicotineCigarsUseFirstInsured',
    title: 'Within the past five (5) years, has the proposed insured used cigars?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotineSnuffUseFirstInsured: {
    id: 'nicotine-snuff-use-first-insured',
    questionRef: 'nicotineSnuffUseFirstInsured',
    title: 'Within the past five (5) years, has the proposed insured used snuff?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotineChewingTobaccoUseFirstInsured: {
    id: 'nicotine-chewing-tobacco-use-first-insured',
    questionRef: 'nicotineChewingTobaccoUseFirstInsured',
    title: 'Within the past five (5) years, has the proposed insured used chewing tobacco?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotinePatchUseFirstInsured: {
    id: 'nicotine-patch-use-first-insured',
    questionRef: 'nicotinePatchUseFirstInsured',
    title: 'Within the past five (5) years, has the proposed insured used a nicotine patch?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotineGumUseFirstInsured: {
    id: 'nicotine-gum-use-first-insured',
    questionRef: 'nicotineGumUseFirstInsured',
    title: 'Within the past five (5) years, has the proposed insured used nicotine gum?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotineVapingUseFirstInsured: {
    id: 'nicotine-vaping-use-first-insured',
    questionRef: 'nicotineVapingUseFirstInsured',
    title: 'Within the past five (5) years, has the proposed insured used vaping products?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotineECigarettesUseFirstInsured: {
    id: 'nicotine-ecigarettes-use-first-insured',
    questionRef: 'nicotineECigarettesUseFirstInsured',
    title: 'Within the past five (5) years, has the proposed insured used e-cigarettes?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotineHookahUseFirstInsured: {
    id: 'nicotine-hookah-use-first-insured',
    questionRef: 'nicotineHookahUseFirstInsured',
    title: 'Within the past five (5) years, has the proposed insured used hookah?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  nicotineCigarettesUseSecondInsured: {
    id: 'nicotine-cigarettes-use-second-insured',
    questionRef: 'nicotineCigarettesUseSecondInsured',
    title: 'Within the past five (5) years, has the proposed insured used cigarettes?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotinePipeUseSecondInsured: {
    id: 'nicotine-pipe-use-second-insured',
    questionRef: 'nicotinePipeUseSecondInsured',
    title: 'Within the past five (5) years, has the proposed insured used a pipe?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotineCigarsUseSecondInsured: {
    id: 'nicotine-cigars-use-second-insured',
    questionRef: 'nicotineCigarsUseSecondInsured',
    title: 'Within the past five (5) years, has the proposed insured used cigars?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotineSnuffUseSecondInsured: {
    id: 'nicotine-snuff-use-second-insured',
    questionRef: 'nicotineSnuffUseSecondInsured',
    title: 'Within the past five (5) years, has the proposed insured used snuff?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotineChewingTobaccoUseSecondInsured: {
    id: 'nicotine-chewing-tobacco-use-second-insured',
    questionRef: 'nicotineChewingTobaccoUseSecondInsured',
    title: 'Within the past five (5) years, has the proposed insured used chewing tobacco?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotinePatchUseSecondInsured: {
    id: 'nicotine-patch-use-second-insured',
    questionRef: 'nicotinePatchUseSecondInsured',
    title: 'Within the past five (5) years, has the proposed insured used a nicotine patch?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotineGumUseSecondInsured: {
    id: 'nicotine-gum-use-second-insured',
    questionRef: 'nicotineGumUseSecondInsured',
    title: 'Within the past five (5) years, has the proposed insured used nicotine gum?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotineVapingUseSecondInsured: {
    id: 'nicotine-vaping-use-second-insured',
    questionRef: 'nicotineVapingUseSecondInsured',
    title: 'Within the past five (5) years, has the proposed insured used vaping products?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotineECigarettesUseSecondInsured: {
    id: 'nicotine-ecigarettes-use-second-insured',
    questionRef: 'nicotineECigarettesUseSecondInsured',
    title: 'Within the past five (5) years, has the proposed insured used e-cigarettes?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  nicotineHookahUseSecondInsured: {
    id: 'nicotine-hookah-use-second-insured',
    questionRef: 'nicotineHookahUseSecondInsured',
    title: 'Within the past five (5) years, has the proposed insured used hookah?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
};
